<template>
  <div class="date-wrapper">
    <date-pick input-class="date-picker-input"
               wrapper-class="date-picker-wrapper"
               :placeholder="placeHolder"
               v-model="dateValue"
               :full-month-name="true"
               :format="customFormatter"
               :disabled-dates="disabledDates"
               :language="lang"
               @selected="onSelected"/>
  </div>
</template>

<script>
import moment from 'moment';
import DatePick from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';

export default {
  name: 'DatePicker',
  components: {
    DatePick,
  },
  props: {
    type: {
      type: String,
      default: 'day',
    },
    placeHolder: {
      type: String,
      default: '날짜를 입력해주세요.',
    },
    value: {},
    disabledRange: {
      type: Array,
      default: () => ([]),
    },
    onSelected: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    dateValue(value) {
      this.$emit('input', value);
    },
  },
  computed: {
    disabledDates() {
      return {
        ranges: [{
          from: this.getTomorrow(),
          to: new Date(9999, 12, 31),
        },
        ...this.disabledRange],
      };
    },
  },
  methods: {
    getTomorrow() {
      const currentDate = new Date();
      return new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
    },

    customFormatter(date) {
      return moment(date).format('YYYY년 MM월 DD일');
    },
  },
  data() {
    return {
      dateValue: this.value || null,
      lang: ko,
    };
  },
};
</script>

<style lang="scss" scoped>
.date-wrapper {
}

@media screen and (max-width: 1024px) {
  .date-wrapper {
    width: 100%;
  }
}
</style>

<style lang="scss">
.date-picker-input {
  width: 130px;
  height: 16px;

  border: none;
  outline: none;

  background-color: transparent;

  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;

  cursor: pointer;
}

.date-picker-wrapper {
  outline: none;
}

@media screen and (max-width: 1024px) {
  .date-picker-input {
    text-align: center;
    height: 30px;
  }

  .date-picker-wrapper {
  }

  .vdp-datepicker__calendar {
    position: fixed;
    left: 50%;
    top: 50%;

    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/date-paginator/Datepicker.vue